/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Blank_RegistrationInputs */

const en_legal_blank_registration = /** @type {(inputs: Legal_Blank_RegistrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[company registration numbers: to be added]`)
};

const pl_legal_blank_registration = /** @type {(inputs: Legal_Blank_RegistrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[numery rejestrowe firmy: do uzupełnienia]`)
};

/**
* | output |
* | --- |
* | "[company registration numbers: to be added]" |
*
* @param {Legal_Blank_RegistrationInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_blank_registration = /** @type {((inputs?: Legal_Blank_RegistrationInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Blank_RegistrationInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_blank_registration(inputs)
	return en_legal_blank_registration(inputs)
});